
/* eslint-disable */
// @ts-nocheck
// @ts-ignore



export const enum Platform {
  PlatformUnknown = 0,
  PlatformWeb = 1,
  PlatformAPP = 2,
  PlatformMiniProgram = 3,
  PlatformPC = 4,
  PlatformPCWeb = 5,
}

export const enum SystemType {
  SystemTypeUnknown = 0,
  SystemTypeAndroid = 1,
  SystemTypeIOS = 2,
  SystemTypeWindows = 3,
  SystemTypeMacOS = 4,
}

export const enum NetType {
  NetTypeUnknown = 0,
  NetTypeWifi = 1,
  NetTypeMobile = 2,
  NetTypeEthernet = 3,
}

export const enum OpenType {
  OpenTypeUnknown = 0,
  OpenTypePush = 1,
  OpenTypeIcon = 2,
  OpenTypeThird = 3,
}

export const enum LoginType {
  LoginTypeUnknown = 0,
  LoginTypeWechat = 1,
  LoginTypeQQ = 2,
  LoginTypeMobile = 3,
  LoginTypeAccount = 4,
}

export const enum GroupJoinType {
  GroupJoinTypeUnknown = 0,
  GroupJoinTypeSearch = 1,
  GroupJoinTypeShare = 2,
  GroupJoinTypeCreate = 3,
}

export const enum GroupTemplateType {
  GroupTemplateTypeUnknown = 0,
  GroupTemplateTypeGame = 1,
  GroupTemplateTypeGuild = 2,
  GroupTemplateTypeKOL = 3,
  GroupTemplateTypeEmpty = 4,
}

export const enum OptPlatform {
  OptPlatformUnknown = 0,
  OptPlatformRESTAPI = 1,
  OptPlatformWeb = 2,
  OptPlatformAndroid = 3,
  OptPlatformIOS = 4,
  OptPlatformWindows = 5,
  OptPlatformMac = 6,
  OptPlatformIPad = 7,
}
